document.addEventListener('DOMContentLoaded', () => {

  /* =========================================
     CONFIG
  ========================================= */

  const CUSTOM_SIZE_VALUE =
    'Custom Size +$60';


  /* =========================================
     ELEMENTS
  ========================================= */

  const modal =
    document.getElementById(
      'CustomSizeModal'
    );


  if (!modal) return;


  const closeButton =
    modal.querySelector(
      '[data-custom-size-close]'
    );


  const confirmButton =
    modal.querySelector(
      '[data-custom-size-confirm]'
    );


  const errorMessage =
    modal.querySelector(
      '[data-custom-size-error]'
    );


  const fields =
    modal.querySelectorAll(
      '[data-custom-size-field]'
    );


  const lengthUnitSelector =
    modal.querySelector(
      '[data-custom-size-length-unit]'
    );


  const weightUnitSelector =
    modal.querySelector(
      '[data-custom-size-weight-unit]'
    );


  const lengthUnitDisplays =
    modal.querySelectorAll(
      '[data-length-unit-display]'
    );


  let customSizeConfirmed =
    false;


  /* =========================================
     UPDATE LENGTH UNIT DISPLAY
  ========================================= */

  function updateLengthUnitDisplay() {

    if (!lengthUnitSelector) return;


    const unit =
      lengthUnitSelector.value;


    lengthUnitDisplays.forEach(
      (element) => {

        element.textContent =
          unit;

      }
    );

  }


  /*
   * When customer changes
   * cm <-> in
   */

  if (lengthUnitSelector) {

    lengthUnitSelector.addEventListener(
      'change',
      () => {

        updateLengthUnitDisplay();

        /*
         * Measurements are NOT automatically converted.
         *
         * Customer should enter the measurements
         * using the selected unit.
         */

      }
    );

  }


  /* =========================================
     OPEN MODAL
  ========================================= */

  function openModal() {

    if (!modal.open) {

      modal.showModal();

    }

  }


  /* =========================================
     CLOSE MODAL
  ========================================= */

  function closeModal() {

    if (modal.open) {

      modal.close();

    }

  }


  /* =========================================
     FIND PRODUCT FORM
  ========================================= */

  function getProductForm() {

    const forms =
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      );


    if (!forms.length) {

      return null;

    }


    /*
     * Prefer visible form
     */

    for (const form of forms) {

      if (
        form.offsetParent !== null
      ) {

        return form;

      }

    }


    return forms[0];

  }


  /* =========================================
     CHECK CUSTOM SIZE SELECTED
  ========================================= */

  function isCustomSizeSelected() {

    /*
     * Check standard form controls
     */

    const controls =
      document.querySelectorAll(
        'input, select'
      );


    for (const control of controls) {

      /*
       * Ignore modal fields
       */

      if (
        modal.contains(control)
      ) {

        continue;

      }


      /*
       * Radio not checked
       */

      if (
        control.type === 'radio' &&
        !control.checked
      ) {

        continue;

      }


      /*
       * Check value
       */

      if (
        control.value &&
        control.value.trim() ===
          CUSTOM_SIZE_VALUE
      ) {

        return true;

      }

    }


    return false;

  }


  /* =========================================
     REMOVE OLD CUSTOM PROPERTIES
  ========================================= */

  function removeCustomSizeProperties() {

    const productForm =
      getProductForm();


    if (!productForm) return;


    const properties =
      productForm.querySelectorAll(
        '[data-custom-size-property]'
      );


    properties.forEach(
      (input) => {

        input.remove();

      }
    );

  }


  /* =========================================
     SAVE DATA TO SHOPIFY
  ========================================= */

  function saveCustomSizeProperties() {

    const productForm =
      getProductForm();


    if (!productForm) {

      console.error(
        'Product form not found.'
      );

      return false;

    }


    /*
     * Remove old properties
     */

    removeCustomSizeProperties();


    /*
     * Get selected units
     */

    const lengthUnit =
      lengthUnitSelector
        ? lengthUnitSelector.value
        : 'cm';


    const weightUnit =
      weightUnitSelector
        ? weightUnitSelector.value
        : 'kg';


    /*
     * Save Size Type
     */

    const sizeType =
      document.createElement('input');


    sizeType.type =
      'hidden';


    sizeType.name =
      'properties[Size Type]';


    sizeType.value =
      'Custom Size +$60';


    sizeType.setAttribute(
      'data-custom-size-property',
      'true'
    );


    productForm.appendChild(
      sizeType
    );


    /*
     * Save Length Unit
     */

    const lengthUnitInput =
      document.createElement('input');


    lengthUnitInput.type =
      'hidden';


    lengthUnitInput.name =
      'properties[Measurement Unit]';


    lengthUnitInput.value =
      lengthUnit;


    lengthUnitInput.setAttribute(
      'data-custom-size-property',
      'true'
    );


    productForm.appendChild(
      lengthUnitInput
    );


    /*
     * Save each measurement
     * including its unit
     */

    fields.forEach(
      (field) => {

        const fieldName =
          field.dataset.customSizeField;


        const hiddenInput =
          document.createElement('input');


        hiddenInput.type =
          'hidden';


        /*
         * Weight uses kg / lb
         * Everything else uses cm / in
         */

        if (
          fieldName === 'Weight'
        ) {

          hiddenInput.name =
            `properties[${fieldName}]`;


          hiddenInput.value =
            `${field.value} ${weightUnit}`;

        } else {

          hiddenInput.name =
            `properties[${fieldName}]`;


          hiddenInput.value =
            `${field.value} ${lengthUnit}`;

        }


        hiddenInput.setAttribute(
          'data-custom-size-property',
          'true'
        );


        productForm.appendChild(
          hiddenInput
        );

      }
    );


    return true;

  }


  /* =========================================
     CLEAR ERRORS
  ========================================= */

  function clearErrors() {

    fields.forEach(
      (field) => {

        field.classList.remove(
          'custom-size-field--error'
        );

      }
    );


    errorMessage.hidden =
      true;

  }


  /* =========================================
     VALIDATE FIELDS
  ========================================= */

  function validateFields() {

    let valid =
      true;


    clearErrors();


    fields.forEach(
      (field) => {

        if (
          !field.value ||
          Number(field.value) <= 0
        ) {

          valid =
            false;


          field.classList.add(
            'custom-size-field--error'
          );

        }

      }
    );


    if (!valid) {

      errorMessage.hidden =
        false;

    }


    return valid;

  }


  /* =========================================
     WATCH SIZE OPTION CHANGE
  ========================================= */

  document.addEventListener(
    'change',
    (event) => {

      const target =
        event.target;


      /*
       * Ignore fields inside modal
       */

      if (
        modal.contains(target)
      ) {

        return;

      }


      /*
       * Custom Size selected
       */

      if (
        target.value &&
        target.value.trim() ===
          CUSTOM_SIZE_VALUE
      ) {

        customSizeConfirmed =
          false;


        removeCustomSizeProperties();


        setTimeout(
          () => {

            openModal();

          },
          150
        );


        return;

      }


      /*
       * Changed back
       * to normal size
       */

      if (
        !isCustomSizeSelected()
      ) {

        customSizeConfirmed =
          false;


        removeCustomSizeProperties();

      }

    }
  );


  /* =========================================
     SUPPORT LABEL / BUTTON CLICK
  ========================================= */

  document.addEventListener(
    'click',
    (event) => {

      const element =
        event.target.closest(
          'label, button'
        );


      if (!element) return;


      /*
       * Don't trigger modal
       * from inside the modal
       */

      if (
        modal.contains(element)
      ) {

        return;

      }


      const text =
        element.textContent
          .trim();


      if (
        text ===
        CUSTOM_SIZE_VALUE
      ) {

        setTimeout(
          () => {

            if (
              isCustomSizeSelected()
            ) {

              customSizeConfirmed =
                false;


              openModal();

            }

          },
          200
        );

      }

    }
  );


  /* =========================================
     CONFIRM CUSTOM SIZE
  ========================================= */

  confirmButton.addEventListener(
    'click',
    () => {

      /*
       * Validate fields
       */

      if (
        !validateFields()
      ) {

        return;

      }


      /*
       * Save data
       */

      const saved =
        saveCustomSizeProperties();


      if (!saved) {

        errorMessage.textContent =
          'Unable to save measurements. Please refresh and try again.';


        errorMessage.hidden =
          false;


        return;

      }


      /*
       * Mark as confirmed
       */

      customSizeConfirmed =
        true;


      /*
       * Close modal
       */

      closeModal();

    }
  );


  /* =========================================
     CLOSE BUTTON
  ========================================= */

  closeButton.addEventListener(
    'click',
    closeModal
  );


  /* =========================================
     PREVENT ADD TO CART
     BEFORE CONFIRMATION
  ========================================= */

  document.addEventListener(
    'submit',
    (event) => {

      const form =
        event.target;


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {

        return;

      }


      /*
       * If Custom Size selected
       * but not confirmed
       */

      if (
        isCustomSizeSelected() &&
        !customSizeConfirmed
      ) {

        event.preventDefault();


        openModal();


        return false;

      }

    },
    true
  );


  /* =========================================
     REMOVE ERROR ON INPUT
  ========================================= */

  fields.forEach(
    (field) => {

      field.addEventListener(
        'input',
        () => {

          field.classList.remove(
            'custom-size-field--error'
          );

        }
      );

    }
  );


  /* =========================================
     MODAL CLOSE
  ========================================= */

  modal.addEventListener(
    'close',
    () => {

      clearErrors();

    }
  );


  /* =========================================
     INITIAL UNIT DISPLAY
  ========================================= */

  updateLengthUnitDisplay();

});